import React from "react";
import { createContext, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import { GetInformationBasicService } from "../../services/InformationBasic/InformationBasicService"

export const InformationBasicContext = createContext();

export const InformationBasicProvider = ({ children }) => {
    const [full_name, setFullName] = useState(null);
    const [companySelected, setCompanySelected] = useState(null);
    const [companies, setCompanies] = useState([]);
    
    const { token } = useContext(AuthContext);

    const GetInformationBasic = async () => {
        const dataInformationBasic = await GetInformationBasicService(token);
        
        if (!dataInformationBasic["error"]) {
            setFullName(dataInformationBasic["content"]["full_name"]);
            setCompanies(dataInformationBasic["content"]["companies"]);
                
            if (dataInformationBasic["content"]["companies"].length > 0) {
                setCompanySelected(dataInformationBasic["content"]["companies"][0]["company_id"]);
            }
            
            return true;
        }

        return false;
    };

    return (
        <InformationBasicContext.Provider value={{ full_name, setFullName, companies, setCompanies, GetInformationBasic, companySelected, setCompanySelected }}>
        {children}
        </InformationBasicContext.Provider>
    );
};
